export const QUERY_KEYS = {
  INVESTOR_PROFILE: 'investor-profile',
} as const;
